export default __webpack_public_path__ + "static/media/gf.bec1d988.svg";